import { render, staticRenderFns } from "./CreateReport.vue?vue&type=template&id=18d658f0"
import script from "./CreateReport.vue?vue&type=script&lang=js"
export * from "./CreateReport.vue?vue&type=script&lang=js"
import style0 from "./CreateReport.vue?vue&type=style&index=0&id=18d658f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports